import { Grid } from "@material-ui/core";
import React from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import { Text, SelectBox } from "sunrise-ui";
import "./Users.scss";

import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

import AddUser from "./AddUser";
import ManageUser from "./ManageUser";
import AddSubContractor from "./AddSubContractor";
import AssignUser from "./AssignUser";
//---for api-------------
import { useDispatch, useSelector } from "react-redux";
import { getUserTypeData } from "../../redux/reducers/users";
import { AppDispatch } from "../../redux/store";
import { uiSliceActions } from "../../redux/reducers/uiState";
import Loader from "../../utilities/Loader";
import SelectOptionMsg from "../../utilities/SelectOptionMsg";
import AssignUnassignLogs from "./assignUnassignLogs";

function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index: any) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
}));

const Users = () => {
  const dispatch = useDispatch<AppDispatch>();
  // -----------loader state------------
  let [loading, setLoading] = React.useState(false);
  // -----------------------------------
  React.useEffect(() => {
    setLoading(true);
    dispatch(
      getUserTypeData({ endPoint: "master-data/get-master-data?type=users" })
    ).then((res) => {
      setLoading(false);
    });
  }, [dispatch]);
  const usersTypeData = useSelector((state: any) => state.USERS.userTypeData);
  const [userType, setUserType] = React.useState<any>("");
  React.useEffect(() => {
    dispatch(uiSliceActions.setUserInitialState());
  }, [dispatch, userType]);
  //------fot tabs-----
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  return (
    <Sidebar>
      {loading ? (
        <Loader color="#5f67e0" loading={loading} size={20} height="80vh" />
      ) : (
        <Grid
          container
          className="users_wrapper p1 bg--white box--shadow"
          style={{ width: "80vw" }}
        >
          <Grid xs={6} md={4} item>
            <Grid className="mb1 mr-1">
              <Text
                type="normal"
                fonts="normal"
                fontSize={18}
                className="mb0 mt0"
              >
                <span className="fw500">Select User Type*</span>
              </Text>
              <SelectBox
                data={[...usersTypeData]}
                placeHolder="Select User Type"
                onChange={(e) => {
                  let target = { ...e };
                  setUserType(target.target.value);
                }}
                borderColor={"primary"}
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            {/* ---------tab area--------- */}
            <Grid className={classes.root}>
              <Tabs
                value={value}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
              >
                <Tab
                  label={`Add/Manage ${userType !== "" ? userType : "User"}`}
                  {...a11yProps(0)}
                />
                {!["Account Manager", "Planning Manager", "P & M"].includes(
                  userType
                ) && (
                  <Tab
                    label={`Assign/Unassign ${
                      userType !== "" ? userType : "User"
                    }`}
                    {...a11yProps(1)}
                  />
                )}
                {!["Account Manager", "Planning Manager", "P & M"].includes(
                  userType
                ) && (
                  <Tab
                    label={"Assign/Unassign History Status"}
                    {...a11yProps(2)}
                  />
                )}
              </Tabs>
              <TabPanel value={value} index={0}>
                {userType?.toLowerCase() !== "sub-contractor" &&
                userType !== "" ? (
                  <>
                    <AddUser userType={userType} />
                  </>
                ) : userType?.toLowerCase() === "sub-contractor" ? (
                  <>
                    <AddSubContractor />
                  </>
                ) : (
                  <></>
                )}
                {userType !== "" ? <ManageUser userType={userType} /> : <></>}
              </TabPanel>
              {userType !== "" && (
                <TabPanel value={value} index={1}>
                  <AssignUser userType={userType} />
                </TabPanel>
              )}
              <TabPanel value={value} index={2}>
                <AssignUnassignLogs role={userType} />
              </TabPanel>
            </Grid>
          </Grid>
          {userType === "" && value !== 2 && (
            <SelectOptionMsg
              text={`Select User type to ${
                value === 0 ? "add or manage" : "assign or unassign"
              } users.`}
            />
          )}
        </Grid>
      )}
    </Sidebar>
  );
};

export default Users;
